module.exports = __webpack_public_path__ + "img/posion.c958ce89.png";